import styled from 'styled-components';

const InputWrapper = styled.label`
  display: grid;
  grid-auto-rows: auto;
  grid-gap: .5rem;
  grid-template-columns: 1fr;
  margin-bottom: 1rem;
  font-weight: 700;

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    grid-gap: ${({ theme }) => theme.grid.columnGap};
    grid-template-columns: 1fr 2fr;
  }
`;

export default InputWrapper;
